// src/locales/si/packingBatch.js
export const packingBatch = {
  qtyPlaceholder: "ප්‍රමාණය",
  // Page Titles
  createPackingBatch: "ඇසුරුම් කණ්ඩායමක් සාදන්න",
  allPackingBatches: "ඇසුරුම් කණ්ඩායම්",
  packingBatchDetails: "ඇසුරුම් කණ්ඩායම් විස්තර",
  createDescription: "ගබඩා සැකසුම් සඳහා නව ඇසුරුම් කණ්ඩායමක් සාදන්න",

  // List Page
  pageDescription: "සියලුම ඇසුරුම් කණ්ඩායම් බලන්න සහ කළමනාකරණය කරන්න",
  allCourierAccounts: "සියලුම කුරියර් ගිණුම්",
  allStatuses: "සියලුම තත්ත්වයන්",
  dateRange: "දින පරාසය",
  searchByBatchNumber: "කණ්ඩායම් අංකයෙන් සොයන්න...",
  noBatchesFound: "කණ්ඩායම් හමු නොවිණි",
  noBatchesFoundDescription: "ඔබගේ සෙවුම් නිර්ණායකවලට කිසිදු කණ්ඩායමක් නොගැලපේ",
  failedToLoadBatches: "ඇසුරුම් කණ්ඩායම් පූරණය කිරීමට අසමත් විය",
  
  // Confirmations
  confirmRetryFailed: "ඔබට කණ්ඩායම් {{batchNumber}} හි අසමත් වූ සියලුම ඇණවුම් නැවත උත්සාහ කිරීමට අවශ්‍ය බව විශ්වාසද?",
  confirmBulkRetry: "කණ්ඩායම් {{count}} කින් අසමත් වූ ඇණවුම් නැවත උත්සාහ කරන්නද?",
  
  // Success/Error Messages
  retrySuccessCount: "ඇණවුම් {{count}} ක් සාර්ථකව නැවත උත්සාහ කරන ලදී",
  noOrdersRetried: "කිසිදු ඇණවුමක් සාර්ථකව නැවත උත්සාහ කළේ නැත",
  noFailedBatchesSelected: "අසමත් වූ ඇණවුම් ඇති කණ්ඩායම් තෝරා නොමැත",
  bulkRetrySuccessful: "කණ්ඩායම් {{count}} කින් සාර්ථකව ඇණවුම් නැවත උත්සාහ කරන ලදී",
  failedToRetrySome: "සමහර කණ්ඩායම් නැවත උත්සාහ කිරීමට අසමත් විය",
  retrySelected: "තෝරාගත් ඒවා නැවත උත්සාහ කරන්න ({{count}})",
  
  // Filters
  selectWarehouse: "ගබඩාව තෝරන්න",
  selectCourier: "කුරියර් සේවය තෝරන්න",
  selectCourierAccount: "කුරියර් ගිණුම තෝරන්න",
  selectCourierRule: "කුරියර් පැවරුම් නීතිය තෝරන්න",
  allOrders: "සියලුම ඇණවුම්",
  selectStatuses: "තත්ත්වයන් තෝරන්න",
  allShops: "සියලුම වෙළඳසැල්",
  allCities: "සියලුම නගර",
  allProducts: "සියලුම භාණ්ඩ",
  searchOrders: "ඇණවුම් සොයන්න",
  courierRule: "කුරියර් පැවරුම් නීතිය",
  courierAccount: "කුරියර් ගිණුම",
  warehouse: "ගබඩාව",
  orderStatus: "ඇණවුම් තත්ත්වය",
  products: "භාණ්ඩ",
  advancedFilters: "උසස් පෙරහන්",
  showAdvanced: "උසස් පෙරහන් පෙන්වන්න",
  hideAdvanced: "උසස් පෙරහන් සඟවන්න",
  searchPlaceholder: "ඇණවුම් අංකය, පාරිභෝගික නම හෝ දුරකථන අංකය...",
  
  // Table Headers
  orderNumber: "ඇණවුම් අං.",
  order: "ඇණවුම",
  customerName: "පාරිභෝගිකයා",
  customer: "පාරිභෝගිකයා",
  phoneNumber: "දුරකථනය",
  shop: "වෙළඳසැල",
  city: "නගරය",
  paymentType: "ගෙවීම් ක්‍රමය",
  payment: "ගෙවීම",
  status: "තත්ත්වය",
  grandTotal: "එකතුව",
  total: "එකතුව",
  itemsPreview: "භාණ්ඩ",
  items: "භාණ්ඩ",
  airwaybillNumber: "ගුවන් බිල් අංකය",
  
  // Batch Creation
  selectedOrders: "තෝරාගත් ඇණවුම්",
  selected: "තෝරාගත්",
  totalValue: "මුළු වටිනාකම",
  notes: "සටහන්",
  notesPlaceholder: "මෙම කණ්ඩායම ගැන යම් සටහන් එක් කරන්න...",
  createBatch: "ඇසුරුම් කණ්ඩායමක් සාදන්න",
  clearSelection: "තේරීම ඉවත් කරන්න",
  account: "ගිණුම",
  
  // Progress
  creatingBatch: "ඇසුරුම් කණ්ඩායම සාදමින්",
  processingOrder: "ඇණවුම සකසමින්",
  of: "න්",
  processing: "සකසමින්",
  success: "සාර්ථකයි",
  failed: "අසමත්",
  creating: "සාදමින්...",
  searching: "සොයමින්...",
  retrying: "නැවත උත්සාහ කරමින්...",
  adding: "එක් කරමින්...",
  
  // Results
  batchCreatedSuccessfully: "කණ්ඩායම සාර්ථකව සාදන ලදී",
  batchNumber: "කණ්ඩායම් අංකය",
  batchNumberTitle: "කණ්ඩායම් අං. {{number}}",
  totalOrders: "මුළු ඇණවුම්",
  successfulOrders: "සාර්ථක",
  failedOrders: "අසමත්",
  viewBatchDetails: "කණ්ඩායම් විස්තර බලන්න",
  createAnotherBatch: "තවත් කණ්ඩායමක් සාදන්න",
  printAirwaybills: "ගුවන් බිල්පත් මුද්‍රණය කරන්න",
  
  // Messages
  noEligibleOrders: "සුදුසු ඇණවුම් හමු නොවිණි",
  selectWarehouseFirst: "කරුණාකර ගබඩාවක් තෝරන්න",
  selectCourierFirst: "කරුණාකර කුරියර් සමාගමක් තෝරන්න",
  selectAtLeastOneOrder: "කරුණාකර අවම වශයෙන් එක් ඇණවුමක් වත් තෝරන්න",
  batchCreationFailed: "ඇසුරුම් කණ්ඩායම සෑදීමට අසමත් විය",
  searchFailed: "ඇණවුම් සෙවීමට අසමත් විය",
  loadBatchError: "කණ්ඩායම් විස්තර පූරණය කිරීමට අසමත් විය",
  noFailedOrders: "නැවත උත්සාහ කිරීමට අසමත් වූ ඇණවුම් නැත",
  retryCompleted: "අසමත් වූ ඇණවුම් නැවත උත්සාහ කිරීම සම්පූර්ණයි",
  retryError: "ඇණවුම් නැවත උත්සාහ කිරීමට අසමත් විය",
  searchOrdersError: "සුදුසු ඇණවුම් සෙවීමට අසමත් විය",
  ordersAddedSuccess: "ඇණවුම් {{count}} ක් සාර්ථකව එක් කරන ලදී",
  addOrdersError: "කණ්ඩායමට ඇණවුම් එක් කිරීමට අසමත් විය",
  largeBatchConfirm: "ඔබ ඇණවුම් {{count}} ක් සහිත කණ්ඩායමක් සෑදීමට සූදානම් වෙයි. මෙයට යම් කාලයක් ගත විය හැක. ඉදිරියට යන්නද?",
  retryConfirm: "අසමත් වූ ඇණවුම් {{count}} ක් නැවත උත්සාහ කරන්නද?",
  
  // Validation
  warehouseRequired: "ගබඩාව අවශ්‍යයි",
  courierRequired: "කුරියර් සමාගම අවශ්‍යයි",
  ordersRequired: "අවම වශයෙන් එක් ඇණවුමක් අවශ්‍යයි",
  
  // Status
  inProgress: "ප්‍රගතියේ",
  completed: "සම්පූර්ණයි",
  partiallyFailed: "අර්ධ වශයෙන් අසමත්",
  statusCompleted: "සම්පූර්ණයි",
  statusInProgress: "ප්‍රගතියේ",
  statusPartiallyFailed: "අර්ධ වශයෙන් අසමත්",
  statusFailed: "අසමත්",
  
  // Actions
  viewAllBatches: "සියලුම කණ්ඩායම් බලන්න",
  retryFailed: "අසමත් වූ ඇණවුම් නැවත උත්සාහ කරන්න",
  retryFailedOrders: "අසමත් වූ ඇණවුම් නැවත උත්සාහ කරන්න",
  retryAll: "සියල්ල නැවත උත්සාහ කරන්න",
  addOrders: "ඇණවුම් එක් කරන්න",
  viewOrder: "ඇණවුම බලන්න",
  copyAirwaybill: "ගුවන් බිල්පත පිටපත් කරන්න",
  
  // Batch Info
  createdBy: "සෑදූ අය",
  createdAt: "සෑදූ දිනය",
  created: "සෑදන ලද",
  by: "විසින්",
  batchStatus: "තත්ත්වය",
  
  // Empty States
  noBatchesYet: "තවම කණ්ඩායම් නැත",
  createFirstBatch: "ඔබගේ පළමු ඇසුරුම් කණ්ඩායම සාදන්න",
  noOrdersFound: "ඇණවුම් හමු නොවිණි",
  adjustFilters: "ඔබගේ පෙරහන් සකස් කිරීමට උත්සාහ කරන්න",
  noMatchingFilters: "ඔබගේ වර්තමාන පෙරහන්වලට ගැලපෙන ඇණවුම් නැත",
  eligibleOrders: "සුදුසු ඇණවුම් ({{count}})",
  
  // Batch List
  batchManagement: "කණ්ඩායම් කළමනාකරණය",
  filterByDate: "දිනය අනුව පෙරීම",
  filterByWarehouse: "ගබඩාව අනුව පෙරීම",
  filterByCourier: "කුරියර් අනුව පෙරීම",
  filterByStatus: "තත්ත්වය අනුව පෙරීම",
  searchByBatchNumber: "කණ්ඩායම් අංකයෙන් සොයන්න",
  applyFilters: "පෙරහන් යොදන්න",
  resetFilters: "පෙරහන් නැවත සකසන්න",
  
  // Statistics
  totalBatches: "මුළු කණ්ඩායම්",
  totalOrdersProcessed: "මුළු සැකසූ ඇණවුම්",
  totalValueProcessed: "මුළු සැකසූ වටිනාකම",
  successRate: "සාර්ථක අනුපාතය",
  
  // Batch Actions
  viewDetails: "විස්තර බලන්න",
  exportBatch: "කණ්ඩායම අපනයනය කරන්න",
  printBatch: "කණ්ඩායම මුද්‍රණය කරන්න",
  backToBatches: "කණ්ඩායම් වෙත ආපසු",
  batchNotFound: "කණ්ඩායම හමු නොවිණි",
  loadingBatch: "කණ්ඩායම් විස්තර පූරණය වෙමින්...",
  
  // Batch Details
  ordersInBatch: "කණ්ඩායමේ ඇණවුම් ({{count}})",
  searchOrdersPlaceholder: "ඇණවුම් සොයන්න...",
  allStatus: "සියලුම තත්ත්වයන්",
  showAll: "සියල්ල පෙන්වන්න",
  failedOnly: "අසමත් වූ ඒවා පමණක්",
  addOrdersToBatch: "කණ්ඩායමට ඇණවුම් එක් කරන්න",
  searchEligiblePrompt: "මෙම කණ්ඩායමට එක් කිරීමට සුදුසු ඇණවුම් සොයන්න",
  addOrdersCount: "ඇණවුම් {{count}} ක් එක් කරන්න",
  addingOrders: "කණ්ඩායමට ඇණවුම් එක් කරමින්",
  selectPrintFormat: "මුද්‍රණ ආකෘතිය තෝරන්න",
  labelFormat: "102mm × 76mm ලේබලය",
  labelFormatDesc: "තාප ලේබල් මුද්‍රණ යන්ත්‍ර සඳහා",
  a4Format: "A4 (පිටුවකට 4)",
  a4FormatDesc: "සම්මත කාර්යාල මුද්‍රණ යන්ත්‍ර සඳහා",
  
  // Counts/Formatting
  ordersCount: "ඇණවුම් {{count}}",
  itemsCount: "භාණ්ඩ {{count}}",
  labelFormatHorizontalQr: "102mm × 76mm Horizontal (Long AWB + QR)",
  labelFormatHorizontalQrDesc: "දිගු airwaybill අංක සහිත කුරියර් සඳහා — සම්පූර්ණ barcode සහ QR කේතය ඇතුළත්",
  labelFormatHorizontalExtended: "102mm × 76mm Horizontal (Extended)",
  labelFormatHorizontalExtendedDesc: "Shows up to 7 items, exchange badge and return waybill",

  // Print Status
  printed: "මුද්‍රණය කළා",
  notPrinted: "මුද්‍රණය නොකළා",
  printedAt: "මුද්‍රණය කළ වේලාව",
  printedBy: "මුද්‍රණය කළේ",
  markPrintedError: "මුද්‍රණ තත්ත්වය සටහන් කිරීම අසාර්ථකයි",

  // Product List View
  productListTitle: "භාණ්ඩ ලැයිස්තුව ({{count}})",
  viewOrdersTab: "ඇණවුම්",
  viewProductsTab: "භාණ්ඩ",
  searchProductsPlaceholder: "භාණ්ඩ සොයන්න...",
  productColumn: "භාණ්ඩය",
  skuColumn: "SKU",
  totalQuantityColumn: "මුළු ප්‍රමාණය",
  orderCountColumn: "ඇණවුම්",
  loadingProductList: "භාණ්ඩ ලැයිස්තුව පූරණය වෙමින්...",
  noProductsFound: "භාණ්ඩ හමු නොවිණි",
  noProductsFoundDescription: "ඔබගේ වත්මන් පෙරහන්වලට කිසිදු භාණ්ඩයක් නොගැලපේ",
  loadProductListError: "භාණ්ඩ ලැයිස්තුව පූරණය කිරීමට අසමත් විය",
  printProductList: "මුද්‍රණය කරන්න",
  exportExcel: "Excel",
  exportPdf: "PDF",
  productListPrintSubtitle: "භාණ්ඩ එකතු කිරීමේ ලැයිස්තුව",

  // Channel
  channel: "නාලිකාව",
  channelOnline: "සබැඳි",
  channelOffline: "නොබැඳි",
  productListPrintTitle: "නිෂ්පාදන ලැයිස්තුව — කණ්ඩායම #{{number}}",
  productListReceiptTitle: "නිෂ්පාදන ලැයිස්තුව",
  productListBatchLabel: "කණ්ඩායම",
  productListPrintedOn: "මුද්‍රණය කළ දිනය",
  receiptTotalProducts: "මුළු නිෂ්පාදන",
  receiptTotalQuantity: "මුළු ප්‍රමාණය",
};

// Courier Upload Format translations
export const courierUpload = {
  // Page Titles
  title: "කුරියර් උඩුගත ආකෘති උත්පාදකය",
  pageTitle: "කුරියර් උඩුගත ආකෘති උත්පාදකය",
  subtitle: "යවන ලද ඇණවුම් සඳහා කුරියර්-විශේෂිත උඩුගත ගොනු ජනනය කරන්න",
  pageDescription: "යවන ලද ඇණවුම් සඳහා කුරියර්-විශේෂිත උඩුගත ගොනු ජනනය කරන්න",
  
  // Tabs
  byPackingBatch: "ඇසුරුම් කණ්ඩායම අනුව",
  byDateCourier: "දිනය සහ කුරියර් අනුව",
  byDateAndCourier: "දිනය සහ කුරියර් අනුව",
  
  // Tooltips
  batchTooltip: "විශේෂිත ඇසුරුම් කණ්ඩායමක සියලුම ඇණවුම් සඳහා උඩුගත ගොනුව ජනනය කරන්න",
  byPackingBatchTooltip: "විශේෂිත ඇසුරුම් කණ්ඩායමක සියලුම ඇණවුම් සඳහා උඩුගත ගොනුව ජනනය කරන්න",
  dateTooltip: "කුරියර් සඳහා නිශ්චිත දිනයක යවන ලද ඇණවුම් සඳහා උඩුගත ගොනුව ජනනය කරන්න",
  byDateAndCourierTooltip: "කුරියර් සඳහා නිශ්චිත දිනයක යවන ලද ඇණවුම් සඳහා උඩුගත ගොනුව ජනනය කරන්න",
  
  // Filters
  selectPackingBatch: "ඇසුරුම් කණ්ඩායම තෝරන්න",
  selectCourierAccount: "කුරියර් ගිණුම තෝරන්න",
  dispatchedDate: "යවන ලද දිනය",
  courierAccount: "කුරියර් ගිණුම",
  packingBatch: "ඇසුරුම් කණ්ඩායම",
  
  // Actions
  generatePreview: "පෙරදසුන ජනනය කරන්න",
  generating: "ජනනය කරමින්...",
  clear: "ඉවත් කරන්න",
  viewPdf: "PDF බලන්න",
  downloadPdf: "PDF බාගන්න",
  pdfTitle: "යවන ලද ඇණවුම්",
  companyName: "සමාගමේ නම",
  courierCompanyLabel: "කුරියර් සමාගම",
  courierRepresentative: "කුරියර් නියෝජිතයා",
  dateLabel: "දිනය",
  timeLabel: "වේලාව",
  dispatchConfirmText: "පහත පාර්සල් යවා බෙදාහැරීම සඳහා කුරියර් නියෝජිතයාට භාර දුන් බව අපි තහවුරු කරමු.",
  totalParcels: "මුළු පාර්සල්",
  totalCodAmount: "මුළු COD මුදල",
  dispatchConfirmation: "යැවීම තහවුරු කිරීම",
  parcelCollectionConfirmation: "පාර්සල් එකතු කිරීම තහවුරු කිරීම",
  name: "නම",
  signature: "අත්සන",
  nameCourier: "නම (කුරියර්)",
  signatureCourier: "අත්සන (කුරියර්)",
  generatedOn: "ජනනය කළේ",
  colNo: "#",
  colWaybill: "Waybill අංකය",
  colOrderNo: "ඇණවුම් අංකය",
  colCity: "නගරය",
  colCod: "COD",
  pdfDownloadSuccess: "PDF සාර්ථකව බාගත විය",
  pdfDataMissing: "PDF දත්ත නොමැත. කරුණාකර backend සේවාදායකය නැවත ආරම්භ කර පෙරදසුන නැවත ජනනය කරන්න.",
  pdfDownloadError: "PDF බාගැනීම අසාර්ථක විය",
  downloadExcel: "Excel බාගන්න",
  downloadCSV: "CSV බාගන්න",
  
  // Summary
  courierCompany: "කුරියර් සමාගම",
  businessAccount: "ව්‍යාපාර ගිණුම",
  mappingFormat: "සිතියම්කරණ ආකෘතිය",
  totalOrders: "මුළු ඇණවුම්",
  generatedAt: "ජනනය කළ වේලාව",
  
  // Preview
  dataPreview: "දත්ත පෙරදසුන",
  showing: "පෙන්වමින්",
  showingRange: "ඇණවුම් {{total}} න් {{from}} සිට {{to}} දක්වා පෙන්වමින්",
  to: "සිට",
  of: "න්",
  orders: "ඇණවුම්",
  ordersCount: "ඇණවුම් {{count}}",
  page: "පිටුව",
  previous: "පෙර",
  next: "ඊළඟ",
  
  // Empty State
  noDataGenerated: "දත්ත ජනනය කර නැත",
  emptyStateMessage: "උඩුගත ආකෘතිය ජනනය කිරීමට ඇසුරුම් කණ්ඩායමක් හෝ කුරියර් ගිණුම සහ දිනය තෝරන්න",
  selectToGenerate: "උඩුගත ආකෘතිය ජනනය කිරීමට ඇසුරුම් කණ්ඩායමක් හෝ කුරියර් ගිණුම සහ දිනය තෝරන්න",
  
  // Messages
  selectBatchFirst: "කරුණාකර ඇසුරුම් කණ්ඩායමක් තෝරන්න",
  selectCourierDateFirst: "කරුණාකර කුරියර් ගිණුම සහ දිනය තෝරන්න",
  selectCourierAndDate: "කරුණාකර කුරියර් ගිණුම සහ දිනය තෝරන්න",
  excelDownloaded: "Excel ගොනුව සාර්ථකව බාගත කරන ලදී",
  excelDownloadSuccess: "Excel ගොනුව සාර්ථකව බාගත කරන ලදී",
  csvDownloaded: "CSV ගොනුව සාර්ථකව බාගත කරන ලදී",
  csvDownloadSuccess: "CSV ගොනුව සාර්ථකව බාගත කරන ලදී",
  failedToGenerate: "පෙරදසුන ජනනය කිරීමට අසමත් විය",
  generateError: "පෙරදසුන ජනනය කිරීමට අසමත් විය",
  failedToDownload: "ගොනුව බාගත කිරීමට අසමත් විය",
  excelDownloadError: "Excel ගොනුව බාගත කිරීමට අසමත් විය",
  csvDownloadError: "CSV ගොනුව බාගත කිරීමට අසමත් විය",
  loadRefDataFailed: "යොමු දත්ත පූරණය කිරීමට අසමත් විය",
  
  // Additional fields
  ordersSheet: "ඇණවුම්",
  batchOption: "කණ්ඩායම් අං. {{id}} - {{courier}} - {{date}} (ඇණවුම් {{orders}})",
  batchNumber: "කණ්ඩායම් අං. {{id}}",
};

// Dispatch translations
export const dispatch = {
  // Page Titles
  pageTitle: "ඇණවුම් යැවීම",
  pageDescription: "ඇණවුම් යැවීමට බාර්කෝඩය ස්කෑන් කරන්න",
  
  // Statistics
  todayDispatches: "අද යවන ලද ඇණවුම්",
  todayValue: "අද වටිනාකම",
  thisSession: "මෙම සැසිය",
  
  // Scan Section
  scanToDispatch: "යැවීමට ස්කෑන් කරන්න",
  orderIdentifier: "ඇණවුම් හඳුනාගැනීම",
  identifierPlaceholder: "බාර්කෝඩය ස්කෑන් කරන්න හෝ ඇණවුම්/ගුවන් බිල් අංකය ඇතුලත් කරන්න...",
  dispatchDate: "යැවීමේ දිනය",
  pastDatesNotAllowed: "අතීත දින අවසර නැත",
  backdatedDispatch: "මෙය පසුගාමී යැවීමකි",
  
  // Actions
  dispatchOrder: "ඇණවුම යවන්න",
  processing: "සකසමින්...",
  
  // Messages
  enterIdentifier: "කරුණාකර ඇණවුම් හඳුනාගැනීමක් ඇතුළත් කරන්න",
  dispatchSuccess: "ඇණවුම {orderNumber} සාර්ථකව යවන ලදී",
  dispatchFailed: "යැවීම අසමත් විය",
  successfullyDispatched: "සාර්ථකව යවන ලදී!",
  
  // Order Details
  orderNumber: "ඇණවුම් අංකය",
  airwaybill: "ගුවන් බිල්පත",
  customer: "පාරිභෝගිකයා",
  status: "තත්ත්වය",
  totalAmount: "මුළු මුදල",
  codAmount: "COD මුදල",
  location: "ස්ථානය",
  phone: "දුරකථනය",
  
  // Keyboard Shortcuts
  keyboardShortcuts: "යතුරුපුවරු කෙටිමං",
  focusInput: "ආදාන ක්ෂේත්‍රය අවධානය යොමු කරන්න",
  submitScan: "ස්කෑනය ඉදිරිපත් කරන්න",
  clearForm: "පෝරමය ඉවත් කරන්න",
  
  // Recent Dispatches
  recentDispatches: "මෑත යැවීම්",
  noDispatchesYet: "මෙම සැසියේ තවම යැවීම් නැත",
  dispatchesWillAppear: "යවන ලද ඇණවුම් මෙහි දිස්වේ",
};

// Print translations
export const print = {
  pageTitle: "ගුවන් බිල්පත් මුද්‍රණය කරන්න",
  batchNumber: "කණ්ඩායම් අං. {{number}}",
  labelsCount: "ලේබල {{count}}",
  printLabels: "ලේබල මුද්‍රණය කරන්න",
  preparing: "සූදානම් කරමින්...",
  format: "ආකෘතිය",
  warehouse: "ගබඩාව",
  courierAccount: "කුරියර් ගිණුම",
  readyToPrint: "මුද්‍රණය කිරීමට සූදානම්",
  loadError: "මුද්‍රණ දත්ත පූරණය කිරීමට අසමත් විය",
  waitForLoad: "කරුණාකර පිටුව සම්පූර්ණයෙන් පූරණය වන තෙක් රැඳී සිටින්න",
  invalidFormat: "වලංගු නොවන මුද්‍රණ ආකෘතිය",
  formatNotSupported: "ආකෘතිය \"{{format}}\" සහාය නොදක්වයි",
  loadingData: "මුද්‍රණ දත්ත පූරණය කරමින්...",
  preparingLabels: "ලේබල {{count}} ක් සූදානම් කරමින්",
  noDataAvailable: "මුද්‍රණ දත්ත නැත",
  unableToLoad: "මෙම කණ්ඩායම සඳහා මුද්‍රණ දත්ත පූරණය කිරීමට නොහැකිය",
  backToBatch: "කණ්ඩායම වෙත ආපසු",
  labelFormat: "102mm × 76mm ලේබලය",
  a4Format: "A4 (පිටුවකට 4)",

  // Missing in dispatch section
  dispatchBatch: "කණ්ඩායම යවන්න",
  dispatching: "යවමින්...",
  confirmDispatch: "ඇණවුම් {{count}} ක් යවන්න",
  noOrdersToDispatch: "යැවීමට ඇණවුම් නැත",
  batchDispatchSuccess: "ඇණවුම් {{count}} ක් සාර්ථකව යවන ලදී",
  dispatched: "යවන ලදී",
  dispatchedOrders: "යවන ලද ඇණවුම්",
  selectOrdersToDispatch: "යැවීමට ඇණවුම් තෝරන්න",
  selectedOrdersCount: "ඇණවුම් {{total}} න් {{selected}} ක් තෝරාගත්",
  sortBy: "Sort By",
  sortDoNotSort: "Do not Sort",
  sortItemsDisplay: "Items Display",
  sortOrderId: "Order ID",
  sortAirwaybillNumber: "Airwaybill Number",
  labelFormatHorizontalQr: "102mm × 76mm Horizontal (Long AWB + QR)",
  labelFormatHorizontalQrDesc: "දිගු airwaybill අංක සහිත කුරියර් සඳහා — සම්පූර්ණ barcode සහ QR කේතය ඇතුළත්",
  labelFormatHorizontalExtended: "102mm × 76mm Horizontal (Extended)",
  labelFormatHorizontalExtendedDesc: "Shows up to 7 items, exchange badge and return waybill",
  markPrintedError: "මුද්‍රණ තත්ත්වය සටහන් කිරීම අසාර්ථකයි",
};